import { Message, RichBlockMessage } from '@botpress/webchat'
import { forwardRef, PropsWithChildren } from 'react'
import { Link, useSearch } from '@tanstack/react-router'
import { cn } from '~/utils'

type MessageProps = PropsWithChildren<RichBlockMessage> & {
  id: string
  workspaceId?: string
  botId?: string
  conversationId?: string
  selected?: boolean
  disableLink?: boolean
  botAvatar?: string
  botName?: string
}

export const MessageItem = forwardRef<HTMLDivElement, MessageProps>(
  (
    {
      direction,
      block,
      disableInput,
      children,
      sender,
      id,
      selected,
      disableLink,
      timestamp,
      workspaceId,
      botId,
      conversationId,
    },
    ref
  ) => {
    const search = useSearch({ strict: false })
    return (
      <div
        className={cn(
          selected &&
            '[&_.bpMessageBlocksBubble]:ring-2 [&_.bpMessageBlocksBubble]:ring-accent-9 [&_.bpMessageBlocksBubble]:ring-offset-2 [&_.bpMessageBlocksBubble]:ring-offset-gray-1'
        )}
        data-disable-input={!!disableInput}
        data-direction={direction}
        data-selected={selected}
        dir="auto"
        ref={ref}
      >
        <Link
          resetScroll={false}
          preload={false}
          to="/workspaces/$workspaceId/bots/$botId/conversations/$conversationId/messages/$messageId"
          params={{
            workspaceId: workspaceId ?? '',
            botId: botId ?? '',
            conversationId: conversationId ?? '',
            messageId: id,
          }}
          search={search}
          disabled={disableLink || !(workspaceId && botId && conversationId)}
        >
          {block && (
            <Message
              id={id}
              direction={direction || 'incoming'}
              timestamp={timestamp}
              block={block}
              sender={sender}
              isReadOnly={true}
            />
          )}
        </Link>
        {children}
      </div>
    )
  }
)

MessageItem.displayName = 'MessageItem'
